// TicketList.jsx
import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { connect } from 'react-redux';

import PackageSrList from './PackageSrList';
import ApprovedSrList from './AdditionalReqWaitForApporve/ApprovedSrList';
import InHouseTechnicianSrList from './InHouseTechnicianSR/InHouseTechnicianSrList';
import GeneralSRList from './GeneralSR/GeneralSRList';


function SR({user}) { 
  return (
    <div className="parent-category">
      <Tabs>
        <TabList className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 tb-list bg-[#fff] shadow-xl p-3 rounded-[5px] text-center'>
            {user?.menu_permissions?.includes("3.3.6") && (
              <Tab>SR List</Tab>
            )}
            {user?.menu_permissions?.includes("3.5.6") && (
              <Tab>Package SR</Tab>
            )}
            {user?.menu_permissions?.includes("3.3.6") && (
              <Tab>In House Technician SR</Tab>
            )}
            {user?.menu_permissions?.includes("3.3.6") && (
              <Tab>General SR</Tab>
            )}
          </TabList>


        {user?.menu_permissions?.includes("3.3.6") && (
        <TabPanel>
            <ApprovedSrList />
        </TabPanel>
        )}
        
        {user?.menu_permissions?.includes("3.5.6") && (
        <TabPanel>
          <PackageSrList />
        </TabPanel>
        )}

      {user?.menu_permissions?.includes("3.3.6") && (
        <TabPanel>
            <InHouseTechnicianSrList />
        </TabPanel>
        )}
        {user?.menu_permissions?.includes("3.3.6") && (
        <TabPanel>
            <GeneralSRList />
        </TabPanel>
        )}
      </Tabs>
    </div>

  );
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(SR);